import { InfoItem } from 'components/molecules/InfoItem/InfoItem';
import { CompanyPageCompanyFragment } from 'generated/graphql';
import { useState } from 'react';
import { Button } from '@spotted-zebra-uk/ui-components';
import { AI_INTERVIEW_SCORE_HIDING_AVAILABLE_LABEL } from './AiInterviewScoreHidingSection.constants';
import AiInterviewScoreHidingSectionForm from './AiInterviewScoreHidingSectionForm';
import styles from './AiInterviewScoreHidingSection.module.scss';

type AiInterviewScoreHidingSectionProps = {
  company: CompanyPageCompanyFragment;
};

const AiInterviewScoreHidingSection = ({
  company,
}: AiInterviewScoreHidingSectionProps) => {
  const [isEditing, setIsEditing] = useState(false);

  return isEditing ? (
    <AiInterviewScoreHidingSectionForm
      company={company}
      onCancelClick={() => setIsEditing(false)}
      onSave={() => setIsEditing(false)}
    />
  ) : (
    <div className={styles.viewContainer}>
      <div className={styles.header}>
        <h3 className={styles.title}>Hide AI interview scores</h3>
        <Button
          variant="secondary"
          size="medium"
          onClick={() => setIsEditing(true)}
        >
          Edit
        </Button>
      </div>
      <div className={styles.content}>
        <InfoItem
          label={AI_INTERVIEW_SCORE_HIDING_AVAILABLE_LABEL}
          value={
            company.isAiInterviewScoreHidingAvailable ? 'Enabled' : 'Disabled'
          }
        />
      </div>
    </div>
  );
};

export default AiInterviewScoreHidingSection;
